export default __webpack_public_path__ + "static/image-antenna-0175e79eb0d5b98d6200d4ff83541eab.png";